import React, { useEffect } from "react";
import PropTypes from "prop-types";
import PopularPostItem from "./popularPostItem/popularPostItem";
import { SECTION_TITLES } from "../../constants/calculators";
import { triggerBuzzClickEvent } from "../../utils/garfieldHelpers";
import DownArrow from "../../assets/images/icons/ic_money_out.svg";
import { EVENT_NAMES } from "../../constants/garfieldEvents";
import "./popularPosts.scss";
import { useState } from "react";
import { isMobile } from "../../utils/breakPoints";
import { POPULAR_POSTS_DATA } from "./popularPosts.constant";

const NUMBER_OF_POSTS = {
  INITIAL: 5,
  FINAL: 10,
};

const PopularPosts = ({
  popularPosts,
  postData,
  sectionId,
  source,
  flow,
}) => {
  const [loadNextClicked, setLoadNextClicked] = useState(
    false
  );
  const [noOfPosts, setNoOfPosts] = useState(
    NUMBER_OF_POSTS.INITIAL
  );

  const popularPostData = popularPosts?.map(popularPost => {
    return postData?.filter(postDataItem => {
      return postDataItem?.uri === popularPost;
    })?.[0];
  });

  if (!popularPostData?.length) {
    return null;
  }
  const handleLinkClick = (title, uri) => {
    triggerBuzzClickEvent(
      EVENT_NAMES.POPULAR_POST_CLICKED,
      {
        [POPULAR_POSTS_DATA.TITLE]: title,
        [POPULAR_POSTS_DATA.URL]: uri,
      },
      sectionId,
      source,
      flow
    );
  };

  useEffect(() => {
    if (isMobile()) {
      setNoOfPosts(NUMBER_OF_POSTS.FINAL);
    }
  }, []);

  return (
    <div className="popular-posts">
      <div className="popular-posts-title rajdhani-font">
        {SECTION_TITLES.MOST_POPULAR}
      </div>
      <div className="posts-container">
        {popularPostData
          .slice(0, noOfPosts)
          .map((popularPost, index) => {
            return (
              <PopularPostItem
                post={popularPost}
                key={popularPost?.id}
                index={index}
                handleLinkClick={() =>
                  handleLinkClick(
                    popularPost?.title,
                    popularPost?.uri
                  )
                }
              />
            );
          })}
      </div>
      {popularPostData.length > NUMBER_OF_POSTS.INITIAL &&
        !loadNextClicked && (
          <div className="load-next-wrap">
            <button
              className="load-next-btn"
              onClick={() => {
                setLoadNextClicked(true);
                setNoOfPosts(NUMBER_OF_POSTS.FINAL);
                triggerBuzzClickEvent(
                  EVENT_NAMES.POPULAR_POST_LOAD_MORE_CLICKED,
                  {
                    [POPULAR_POSTS_DATA.NO_OF_POSTS]:
                      NUMBER_OF_POSTS.FINAL,
                  },
                  sectionId,
                  source,
                  flow
                );
              }}
            >
              Load Next {NUMBER_OF_POSTS.INITIAL}{" "}
              <img src={DownArrow} alt="Down Arrow" />
            </button>
          </div>
        )}
    </div>
  );
};

PopularPosts.propTypes = {
  popularPosts: PropTypes.array,
  postData: PropTypes.object,
  sectionId: PropTypes.string,
  source: PropTypes.string,
  flow: PropTypes.string,
};

export default PopularPosts;
